import styled from '@tanium/react-emotion-9';
import { css } from '@tanium/style-system';
import { ThemeSpace, ThemeZIndices } from '@tanium/theme-data';
import { BackdropFilter, Border, Fill, FillWithAlpha, Shadow, Text } from './themeDefinitions';
import { TooltipProps } from './types';

/**
 * Wrapper for the tooltip component's content.
 */
export const TooltipContentWrapper = styled('div')<Pick<TooltipProps, 'opacity'>>(({ opacity }) =>
  css((theme) => ({
    border: 1,
    boxSizing: 'border-box',
    borderColor: Border,
    borderRadius: 1,
    color: Text,
    padding: ThemeSpace.bordered[1],
    backgroundColor: Fill,
    margin: 1,
    fontSize: 12,
    maxWidth: 300,
    wordWrap: 'break-word',
    textAlign: 'center',
    boxShadow: Shadow(theme),
    zIndex: ThemeZIndices.Popover,
    ...(BackdropFilter(theme) && {
      [`@supports (backdrop-filter: ${BackdropFilter(theme)})`]: {
        backdropFilter: BackdropFilter(theme),
        backgroundColor: FillWithAlpha(opacity),
      },
    }),
  })),
);
